import SecretsSecurity from '@/components/pages/secrets/Security'

export default function Security() {
  return (
    <>
      <SecretsSecurity />
    </>
  )
}
